export const LABELS = {
    equipmentCatalog: "Equipment Catalog",
    fileUpload: {
        dragAndDrop: "Drag and drop your files here",
        selectFile: "Select a file to upload",
    },
    id: "Id",
    pump: "Pump",
    series: "Series",
    pnDescription: "PN description",
    length: "Length",
    weight: "Weight",
    standardization: "Standardization",
    noOfStages: "# of stages",
    od: "OD",
    shaftType: "Shaft type",
    date: "Date",
    action: "Action",
    user: "User",
    partNumber: "Part number",
    cable: "Cable",
};